module.exports = __webpack_public_path__ + "img/nono.294fb735.gif";